module.exports = __webpack_public_path__ + "static/media/UpCaret.fb13389a.svg";